import { Typography } from '@material-ui/core'
import React, { memo } from 'react'
import { useTrackChangesCardStyles } from '../../styles/useTrackChangesCardStyles'

export const NoChangesMessage = memo(() => {
    const classes = useTrackChangesCardStyles({})

    return (
        <Typography
            className={classes.noChangesText}
            data-testid="no-changes-message"
        >
            No changes have been made
        </Typography>
    )
})
